import { createApi } from '@reduxjs/toolkit/query/react';
import { ITeamReadModel, ITeamWriteModel } from '../../models/team';
import { createRbacBaseQuery, del, listToCacheTags, post, put } from '../../utils/helpers';

const teamApi = createApi({
    reducerPath: 'team',
    tagTypes: ['Team', 'TeamList', 'ListByMemberId'],
    baseQuery: createRbacBaseQuery('/teams'),
    endpoints: (builder) => ({
        getTeams: builder.query<ITeamReadModel[], void>({
            query: () => '',
            providesTags: res => listToCacheTags(res, 'Team', 'TeamList'),
        }),
        getTeamsByMember: builder.query<ITeamReadModel[], string>({
            query: memberId => `/bymember/${memberId}`,
            providesTags: res => listToCacheTags(res, 'Team', 'ListByMemberId'),
        }),
        getTeamById: builder.query<ITeamReadModel, string>({
            query: teamId => teamId,
            providesTags: (_, __, teamId) => [{ type: 'Team', id: teamId }],
        }),
        createTeam: builder.mutation<ITeamReadModel, ITeamWriteModel>({
            query: team => post('', team),
            invalidatesTags: ['TeamList'],
        }),
        updateTeam: builder.mutation<ITeamReadModel, { teamId: string, team: ITeamWriteModel }>({
            query: ({ teamId, team }) => put(teamId, team),
            invalidatesTags: (_, __, args) => [{ type: 'Team', id: args.teamId }],
        }),
        deleteTeam: builder.mutation<ITeamReadModel, string>({
            query: teamId => del(teamId),
            invalidatesTags: ['TeamList'],
        }),
    }),
});

export default teamApi;

export const {
    useGetTeamByIdQuery,
    useGetTeamsQuery,
    useGetTeamsByMemberQuery,
    useCreateTeamMutation,
    useUpdateTeamMutation,
    useDeleteTeamMutation,
} = teamApi;